import apiClient from '@/api/client'
import { getApiBaseUrl } from '@/api/base-url'

export interface CarrierTerminalOption {
  id: string
  name: string
  address: string
}

export interface DeliveryQuote {
  is_manual: boolean
  price: string | null
  currency: string | null
}

export const deliveryApi = {
  /** Терминалы перевозчика в городе (провайдер отдаёт уже готовый список, например Деловые Линии). */
  async getTerminals(cityId: number): Promise<CarrierTerminalOption[]> {
    const apiUrl = getApiBaseUrl()
    const response = await apiClient.get(`${apiUrl}/api/delivery/terminals`, {
      params: { city_id: cityId },
    })

    return response.data?.data?.terminals ?? []
  },

  /** Расчёт стоимости доставки; ручной расчёт (is_manual) — цены нет. */
  async getQuote(cityId: number, method: 'terminal' | 'address'): Promise<DeliveryQuote | null> {
    const apiUrl = getApiBaseUrl()
    const response = await apiClient.get(`${apiUrl}/api/delivery/quote`, {
      params: { city_id: cityId, method },
    })

    return response.data?.data ?? null
  },
}

/**
 * Цена из строки вида "1 114.00 RUB" в рублях (number).
 * Пробелы — разделители тысяч, поэтому простой parseFloat не подходит.
 */
export function quotePriceToRubles(price: string | null): number | null {
  if (price === null) return null
  const normalized = price.replace(/[^\d.,-]/g, '').replace(/\s/g, '').replace(',', '.')
  if (normalized === '' || normalized === '-' || normalized === '.') return null
  const value = Number(normalized)
  return Number.isFinite(value) ? value : null
}
